import { AppAuthContext } from "@/authentication"
import { type RequestOptions } from "vue-utils"
import { BasicHttpService } from "./httpHelper"

export class SARLogHttpService extends BasicHttpService {
	override async fetch(request: RequestOptions): Promise<Response> {
		let authToken: string | null = null
		try {
			authToken = await AppAuthContext.getBearerToken()
		} catch (e) {
			console.error("Failed to get auth token", e)
		}

		//If the user is not logged in (or getting the token fails), attempt the API call anyway
		//Best case scenario, it doesn't require authentication. Worst case scenario, the user gets an Unauthorized response
		if (authToken) {
			const headers = (request.headers ?? {}) as Record<string, string>
			headers.Authorization = `Bearer ${authToken}`
			request.headers = headers
		}

		return super.fetch(request)
	}
}
